import * as React from 'react';
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';

const GuideAboutCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about-card', 'flex min-h-[476px] w-[220px] max-w-full flex-grow flex-col', 'gap-3 rounded-xl border border-neutral-lightest bg-white p-5 shadow-dropshadow-lg', className)}
    {...props}
  />
));
GuideAboutCard.displayName = 'GuideAboutCard';

const GuideAboutCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn('c-guide-about-card-header', '', className)}
    {...props}
  />
));
GuideAboutCardHeader.displayName = 'GuideAboutCardHeader';

const GuideAboutCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-guide-about-card-title', 'mb-0 text-lg font-bold leading-tight text-primary-dark', className)}
    {...props}
  />
));
GuideAboutCardTitle.displayName = 'GuideAboutCardTitle';

const guideAboutCardBodyVariants = cva('flex flex-col flex-grow [&>.c-empty-state]:m-auto', {
  variants: {
    isEmpty: {
      true: 'rounded-xl border border-solid border-neutral-lightest bg-neutral-bright'
    }
  },
  defaultVariants: {
    isEmpty: false
  }
});

const GuideAboutCardBody = React.forwardRef(({ className, isEmpty, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about-card-body', guideAboutCardBodyVariants({ isEmpty, className }))}
    {...props}
  />
));

const GuideAboutCardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <footer
    ref={ref}
    className={cn('c-guide-about-card-footer', '', className)}
    {...props}
  />
));
GuideAboutCardFooter.displayName = 'GuideAboutCardFooter';

export { GuideAboutCard, GuideAboutCardHeader, GuideAboutCardTitle, GuideAboutCardBody, GuideAboutCardFooter };
